const LS_KEY = {
  USER_INFO: 'userInfo',
  LOGIN_VALIDATION: 'loginValidation',
};

export default LS_KEY;
